import * as React from 'react'

import SvgSprite from 'airship/patterns/svg-sprite'
import {DMColors, SpriteName} from 'airship/patterns/types'

import Popover, {Props as PopoverProps} from '../Popover'
import styles from './HelpIcon.module.css'

type PopoverOptions = Pick<PopoverProps, 'align' | 'position'>

type Props = PopoverOptions & {
  content: React.ReactNode
  color?: DMColors
  displayClasses?: string
  spriteName?: SpriteName
  popoverSpacing?: number
}

const HelpIcon: React.FunctionComponent<Props> = ({
  content,
  color = 'grey-60',
  displayClasses = 'u-text-shrink-1',
  spriteName = 'help-fill',
  popoverSpacing,
  ...rest
}) => {
  const [isOpen, setIsOpen] = React.useState(false)

  return (
    <Popover
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      targetElement={
        // Ideally clicking the HelpIcon would toggle the help text, but making
        // this icon a <button> breaks our common use case of putting HelpIcon
        // in form field labels: the label becomes associated with the HelpIcon
        // button instead of the form field.
        <span
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
        >
          <SvgSprite
            name={spriteName}
            color={color}
            displayClasses={displayClasses}
          />
        </span>
      }
      displayClasses={styles.tooltip}
      arrowColor="black"
      spacing={popoverSpacing}
      {...rest}
    >
      <div className={styles.tooltipContent}>{content}</div>
    </Popover>
  )
}

export default HelpIcon
